import { PortalNeutralButton } from '@/components/common/PortalNeutralButton';
import useLanguage from '@/utils/hooks/useLanguage';
import SearchFilter from './SearchFilter';

interface GeneralSearchFilterProps {
    globalFilter: string;
    setGlobalFilter: (filter: string) => void;
    onReset: () => void;
}

const GeneralSearchFilter = (props: GeneralSearchFilterProps) => {
    const { globalFilter, setGlobalFilter, onReset } = props;
    const lang = useLanguage();
    return (
        <>
            <div className="flex items-center gap-3">
                <SearchFilter filter={globalFilter} setFilter={setGlobalFilter} />
            </div>
            <div className="flex flex-start h-[34px] gap-3">
                <PortalNeutralButton onClick={onReset}>{lang.common.reset}</PortalNeutralButton>
            </div>
        </>
    );
};

export default GeneralSearchFilter;
